import ParseqUI from './ParseqUI';

const Deforum = () => {
  return (<>
    {/* @ts-ignore */}
    <ParseqUI
      defaultTemplate='catduck'/>
  </>)
}

export default Deforum;

